import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ProductFlowService, ProductFlowConfig } from 'app/infrastructure/services/productFlow.service';
import { RuleService } from 'app/infrastructure/services/reglas.service';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { Location } from '@angular/common';
import { SxHttpService } from 'app/infrastructure/services/sxHttp.service';
import { CacheService } from 'app/infrastructure/services/cache.service';

import { SxDocumentTypes } from 'app/private/sxfdesigner/components/main/completeContext';
import { TimeZoneService } from 'app/infrastructure/services/timeZoneService.service';
import { moment } from 'moment-timezone';
import { FlowDynamicStyle, DatetimeLocales, DatetimeFormats } from 'app/infrastructure/model/interfaces/flowDynamicStyle.interface';

@Component({
  selector: 'sx-product-flow-style-config',
  templateUrl: './dynamicStyleConfiguration.component.html',
})
export class ProductFlowDynamicStylesComponent implements OnInit {

  codSistema: string;
  codNegocio: string;
  codProduct: string;
  codFlow: string;
  documentKind: string;
  standardKey: string = null;

  config: FlowDynamicStyle = {
    systemCode: '',
    businessCode: '',
    productCode: '',
    kind: '',
    codFlow: '',
    dateTimeStyle:
    {
      dateTimeLocale: '',
      dateTimeFormat: ''
    },
    globalFlowStyles: {
      hideSideBar: false
    },
    standardKey: null
  };

  //#region Datetime formaters
  dateTimeLocaleOpcions: string[] = DatetimeLocales;
  dateTimeFormatOptions: string[] = DatetimeFormats;
  //#endregion


  constructor(private productFlowService: ProductFlowService,
    private alert: AlertService,
    private router: Router,
    private _location: Location,
    private aRoute: ActivatedRoute,
    private http: SxHttpService,
    private alertService: AlertService,
    private timeZoneService: TimeZoneService
  ) { }

  ngOnInit() {
    const moment = require('moment-timezone');

    this.aRoute.params.subscribe((params: Params) => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codProduct = params['codproducto'];
      this.codFlow = params['codFlow'];
      this.documentKind = params['documentKind'];
      if (!this.codSistema)
        this.standardKey = 'standardDictionary';

      this.config.systemCode = this.codSistema;
      this.config.businessCode = this.codNegocio;
      this.config.productCode = this.codProduct;
      this.config.kind = this.documentKind;
      this.config.codFlow = this.codFlow;

      if (this.codNegocio === undefined) {
        this.codNegocio = 'null';
      }

      if (this.codProduct === undefined) {
        this.codProduct = 'null';
      }

      if (this.documentKind === undefined) {
        this.documentKind = SxDocumentTypes.None;
      }

      if (this.codFlow === undefined) {
        this.alert.showGrowl({
          type: GrowlType.WARNING,
          body: 'INVALID_NAME',
        });
      } else {
        this.productFlowService.getDynamicStyle(this.codSistema, this.codNegocio, this.codProduct, this.codFlow, this.documentKind, this.standardKey)
          .subscribe(x => {
            this.config = x;
          });
      }
    });
  }

  onSaveChanges() {
    this.productFlowService.saveDynamicStyle(this.config)
      .then((x) => {
        if (x) {
          this.alert.showGrowl({
            type: GrowlType.SUCCESS,
            body: 'FLOW_STYLE_SAVE_SUCCESS',
          });
        } else {
          this.alert.showGrowl({
            type: GrowlType.DANGER,
            body: 'FLOW_STYLE_SAVE_FAIL',
          });
        }
      });
  }

  back() {
    this._location.back();
  }

  onPrototypeChange(event: any) {
    this.config.dateTimeStyle.dateTimeFormat = event.srcElement.value;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/dynamicFlow/DynamicStyleConfiguration/dynamicStyleConfiguration.component.ts